import React, { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import { Box, Stack, Grid, Button, Link } from '@mui/material';
import { LinkedIn as LinkedInIcon } from '@mui/icons-material'; // ✅ Fixed Icon import
import IconButton from '@mui/material/IconButton'; // ✅ Fixed Icon import
import { PlayArrowRounded as Play } from '@mui/icons-material'; // ✅ Fixed Icon import
import { useLocation, Link as RouterLink } from 'react-router-dom'; // ✅ Cleaned up Router imports

import '../../styles/mobidawg-style.scss';
import { app, analytics, logEvent } from '../../services/firebase.tsx';
import CreativeImage from '../../assets/images/mobidawg_creative.png';
import CreativeVideo from '../../assets/video/mobidawg_creative.mp4';

// Define a reusable style object for paragraph spacing
const paragraphStyle = { mb: 3 }; // mb = margin-bottom, adjust as needed


function About() {
    const [playVideo, setPlayVideo] = useState(false);
    const videoRef = useRef(null);

    const handleMediaClick = () => {
        setPlayVideo(true);
        // Directly invoking play within the user gesture handler unlocks audio on localhost & production
        setTimeout(() => {
        if (videoRef.current) {
            videoRef.current.play().catch((err) => console.warn("Playback error:", err));
        }
        }, 50);
    };
    
    const location = useLocation();

    // A/B Test setup
    // For now, we'll manually set the variant.
    // In a real scenario, this could come from a feature flag service,
    // user segmentation, or a random assignment.
    const variantToShow = 'B'; // 'A' for old, 'B' for new

    useEffect(() => {
        logEvent(analytics, 'page_view', {
            page_location: window.location.href,
            page_path: location.pathname,
            page_title: document.title,
            ab_test_variant: `about_page_variant_${variantToShow}` // Log the variant
        })

        if (location.pathname === '/about') {
            logEvent(analytics, 'about_page_loaded', {
                ab_test_variant: `about_page_variant_${variantToShow}` // Log the variant
            });
        }
    }, [location, variantToShow]);

    // Variant A (Old Messaging)
    const VariantA = () => (
        <>
            <Typography variant="body1" sx={paragraphStyle}>
                Welcome to mobidawg, llc.  Let me tell you about my company ...
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
              mobidawg was founded with a passion for building modern, web-integrated 
              mobile applications. With 30+ years of experience in software engineering, 
              I focus on delivering robust applications that help businesses grow and 
              adapt in a digital world.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
              My expertise spans full-stack development, cloud integration, and mobile application
              development natively or with cross-platform development tools (I can even address legacy
              mobile in Android/Java or iOS/Objective-C). I will work with your Design team to bring
              your ideas to life, or I can bring some Designers in to help. I work in collaboration with
              AI tools to help me be more efficient and effective. I can also help you
              integrate AI into your applications, whether it be for data analysis,
              customer service, or any other use case you can think of. I have experience
              with a variety of AI tools and platforms, and I can help you choose the right
              solution for your needs.
              I believe in continuous learning and leveraging the 
              latest technologies to solve real-world problems efficiently.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
              Whether you’re a startup or an established company, I’m committed to 
              providing personalized solutions that fit your unique needs. 
              Let’s work together to bring your ideas to life!
            </Typography>
        </>
    );

    // Variant B (New Messaging)
    const VariantB = () => (
        <>
            <Typography variant="body1" sx={paragraphStyle}>
                In today's market, you know that embracing Artificial Intelligence isn't just an option—it's essential to avoid 
                becoming irrelevant. But for a small business, the path to AI integration can seem complex and overwhelming. 
                Where do you even begin?
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                That's where mobidawg comes in. I specialize in helping small businesses like yours navigate the world of AI, 
                not with a disruptive overhaul, but through step-wise, continuous improvements. We'll work together to embed 
                intelligent, agentic AI capabilities directly into your existing web or mobile applications, unlocking new 
                efficiencies and creating smarter customer experiences.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                My focus is on practical, tailored solutions—from AI readiness assessments to building custom AI agents that 
                automate tasks, provide insights, and drive growth. With over 30 years of software engineering experience, 
                I bridge the gap between cutting-edge technology and your real-world business needs.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                Don't let your business be left behind. Let's start your AI journey with a simple, manageable first step. 
                Together, we can build a more intelligent future for your company.
            </Typography>
        </>
    );

    console.log('mobidawg Button type:', typeof Button);
    console.log('mobidawg LinkedInIcon type:', typeof LinkedIn, LinkedInIcon);

    return (
        <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={7} lg={8}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    About
                </Typography>
    
                {variantToShow === 'A' && <VariantA />}
                {variantToShow === 'B' && <VariantB />}
    
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        to="/contactform"
                    >
                        Contact Me For A Consultation
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<LinkedInIcon />}
                        href="https://www.linkedin.com/in/bobjames?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BHTWK5PkLSvidVKghyM5nOA%3D%3D"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View LinkedIn Profile
                    </Button>
                </Stack>
            </Grid>
            <Grid item 
                xs={12} md={5} lg={4} 
                sx={{ mt: { xs: 2, md: 6 }, position: 'relative', cursor: 'pointer' }} 
                onClick={handleMediaClick}   //{() => setPlayVideo(true)}
            >
                <Box 
                    component="img" 
                    src={CreativeImage} 
                    alt="A creative depiction of a dog made from electronic circuit patterns." 
                    sx={{ 
                            visibility: playVideo ? 'hidden' : 'visible',
                            position: 'relative', 
                            top: 0, 
                            left: 0, 
                            width: '100%', 
                            height: '100%', 
                            borderRadius: '8px', 
                            objectFit: 'cover' 
                        }}
                />

                <IconButton
                    aria-label="Play Video"
                    onClick={handleMediaClick}
                    sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                >
                    <Play style={{ fontSize: 60, color: 'rgb(59, 11, 234)' }} />
                </IconButton>


                {playVideo && (
                        <Box
                        component="video"
                        ref={videoRef}
                        src={CreativeVideo}
                        playsInline
                        /* Notice: muted is removed so full audio plays! */
                        onEnded={() => setPlayVideo(false)}
                        onClick={() => setPlayVideo(false)} // Allow user to click to stop video
                        sx={{ 
                            position: 'absolute', 
                            top: 0, 
                            left: 0, 
                            width: '100%', 
                            height: '100%', 
                            borderRadius: '8px', 
                            objectFit: 'cover' 
                        }}
                        />
                    )}

            </Grid>
        </Grid>
    );
}

export default About;